/**
 * Photo Migration Detector
 * 
 * Detects partial migrations where main_photo_url is v1.5 but profile_photos[] contains v1 URLs.
 */

/**
 * Detecta se um usuário tem migração parcial (v1.5 na main_photo mas v1 no array)
 */
export function hasPartialMigration(
  mainPhotoUrl: string,
  profilePhotos: string[],
  photoVersion: string
): boolean {
  // Se não é v1.5, não é migração parcial
  if (photoVersion !== 'v1.5') return false;
  
  // Se não tem profile_photos, não precisa migrar
  if (!profilePhotos || profilePhotos.length === 0) return false;
  
  // Checar se alguma foto no array é v1 (contém username ou formato antigo)
  const hasV1Photos = profilePhotos.some(url => {
    // URL v1 contém username ou formato público antigo
    return url.includes('/object/public/') || 
           /[a-z]+-\d{13}\.jpg/i.test(url); // Padrão: nome-timestamp.jpg
  });
  
  return hasV1Photos;
}
